<template>
  <template v-if="!isResult">
    <p>{{ dateFormatMMDD(detailData.dakoku_date) }}</p>

    <div class="form-item">
      <label>{{ syouninStr }}</label>
      <div class="before-after">
        <p>{{ detailData.syounin_status_notes ? detailData.syounin_status_notes : 'コメントなし' }}</p>
      </div>
    </div>

    <div class="form-item">
      <label>出勤</label>
      <div class="before-after">
        <p class="before">{{ detailData.syukkin_round_datetime ? timeFormatter(detailData.syukkin_round_datetime) : '記録なし' }}</p>
        <p class="after">{{ detailData.syukkin_datetime ? '(' + timeFormatter(detailData.syukkin_datetime) + ')' : '' }}</p>
      </div>
    </div>

    <div class="form-item">
      <label>退勤</label>
      <div class="before-after">
        <p class="before">{{ detailData.taikin_round_datetime ? timeFormatter(detailData.taikin_round_datetime) : '記録なし' }}</p>
        <p class="after">{{ detailData.taikin_datetime ? '(' + timeFormatter(detailData.taikin_datetime) + ')' : '' }}</p>
      </div>
    </div>

    <div class="form-item">
      <label>外出</label>
      <div class="before-after">
        <p class="before">{{ detailData.gaisyutsu_round_datetime ? timeFormatter(detailData.gaisyutsu_round_datetime) : '記録なし' }}</p>
        <p class="after">{{ detailData.gaisyutsu_datetime ? '(' +  timeFormatter(detailData.gaisyutsu_datetime) + ')' : '' }}</p>
      </div>
    </div>

    <div class="form-item">
      <label>戻り</label>
      <div class="before-after">
        <p class="before">{{ detailData.modori_round_datetime ? timeFormatter(detailData.modori_round_datetime) : '記録なし' }}</p>
        <p class="after">{{ detailData.modori_datetime ? '(' +  timeFormatter(detailData.modori_datetime) + ')' : '' }}</p>
      </div>
    </div>

    <div class="form-item">
      <label>休憩</label>
      <div class="before-after">
        <p class="before">{{ detailData.kyuukei_round_times ? timeToHHmm(detailData.kyuukei_round_times) : '記録なし' }}</p>
        <p class="after">{{ detailData.kyuukei_times ? '(' +  timeToHHmm(detailData.kyuukei_times) + ')' : '' }}</p>
      </div>
    </div>

    <div class="form-item">
      <label>所定労働時間</label>
      <div class="before-after">
        <p class="before">{{ detailData.syotei_work_times ? timeToHHmm(detailData.syotei_work_times) : 'なし' }}</p>
      </div>
    </div>

    <div class="form-item">
      <label>控除時間</label>
      <div class="before-after">
        <p class="before">{{ detailData.koujo_times ? timeToHHmm(detailData.koujo_times) : 'なし' }}</p>
      </div>
    </div>

    <div class="form-item">
      <label>法定内残業</label>
      <div class="before-after">
        <p class="before">{{ detailData.houteinai_zangyou_times ? timeToHHmm(detailData.houteinai_zangyou_times) : 'なし' }}</p>
      </div>
    </div>

    <div class="form-item">
      <label>時間外</label>
      <div class="before-after">
        <p class="before">{{ detailData.jikangai_work_times ? timeToHHmm(detailData.jikangai_work_times) : 'なし' }}</p>
      </div>
    </div>

    <div class="form-item">
      <label>深夜割増</label>
      <div class="before-after">
        <p class="before">{{ detailData.shinya_warimashi_times ? timeToHHmm(detailData.shinya_warimashi_times) : 'なし' }}</p>
      </div>
    </div>

    <div class="form-item">
      <label>遅刻</label>
      <div class="before-after">
        <p class="before" v-bind:class="{ 'p-color-red': detailData.chikoku_times }">{{ detailData.chikoku_times ? timeToHHmm(detailData.chikoku_times) : 'なし' }}</p>
      </div>
    </div>

    <div class="form-item">
      <label>早退</label>
      <div class="before-after">
        <p class="before" v-bind:class="{ 'p-color-red': detailData.soutai_times }">{{ detailData.soutai_times ? timeToHHmm(detailData.soutai_times) : 'なし' }}</p>
      </div>
    </div>

    <shinseis :hayabanOsobanData="hayabanOsobanData" :shinseis="shinseis" :detailData="detailData"></shinseis>
<!--
    <div class="form-item">
      <div class="form-edit-btton">
        <label>本人コメント</label>
        <p @click="openHonninNotesModal()" class="link-text"
            v-if="detailData.syounin_status_type !== OptionConst.DAKOKU_SYOUNIN_STATUS.APPROVED">
            <template v-if=detailData.honnin_notes>編集</template>
            <template v-else>登録</template>
        </p>
      </div>
      <div class="before-after">
        <p>{{ detailData.honnin_notes ? detailData.honnin_notes : 'なし' }}</p>
      </div>
    </div> -->

    <div class="buttons button-select">
      <button type="button" class="btn cancel" @click="close()"><i class="fa-solid fa-x"></i>閉じる</button>
    </div>
  </template>
  <template v-if="isResult">
    <div class="buttons">
      <button type="button" class="btn cancel" @click="close()"><i class="fa-solid fa-x"></i>閉じる</button>
    </div>
  </template>
</template>

<script lang="ts">
import { timeFormat, timeToHHmm, dateFormatMMDD } from "@/filters/common";
import { computed, defineComponent, onMounted, ref } from 'vue';
import OptionConst from '@/const/Option';
import { DakokuDataFull, DakokuDetailData, DakokuInfoShinsei } from '@/types/Dakoku';
import { HayabanOsoban } from '@/types/Shinsei';
import Shinseis from '@/components/dakoku/syuusei_parts/Shinseis.vue';

export default defineComponent({
  props: {
    detailData: {
      type: Object as () => DakokuDetailData,
      default: null
    },
    syouninStr: {
      type: String,
      default: null
    },
    shinseis: {
      type: Object as () => DakokuInfoShinsei,
      default: null
    },
    hayabanOsobanData: {
      type: Object as () => HayabanOsoban,
      default: null
    },
  },
  emits: {
    close: () => true,
    openHonninNotesModal: (kinmu: DakokuDataFull) => true,
    updateHonninNotes: () => true,
  },
  setup(props, context) {

    const isResult = ref(false)

    const close = () => {
      context.emit('close');
    }

    const detailData = computed(() => {
      return props.detailData
    })

    const timeFormatter = (time: Date |string ): string => {
      return timeFormat(time);
    }

    const openHonninNotesModal = async() => {
      context.emit('openHonninNotesModal', detailData.value as DakokuDataFull);
      close()
    }

    return {
      close,
      timeFormatter,
      timeToHHmm,
      dateFormatMMDD,
      detailData,
      isResult,
      OptionConst,
      openHonninNotesModal,
    }
  },
  components: {
    'shinseis': Shinseis,
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/dialog/dakoku-syuusei.scss';
</style>
